import { render, staticRenderFns } from "./CostPerFob.vue?vue&type=template&id=ab927f04&scoped=true"
import script from "./CostPerFob.vue?vue&type=script&lang=js"
export * from "./CostPerFob.vue?vue&type=script&lang=js"
import style0 from "./CostPerFob.vue?vue&type=style&index=0&id=ab927f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab927f04",
  null
  
)

export default component.exports